import React from 'react'
import { DesignedModal, Button } from '@clickcease/cc-client-components-lib'
import { useTranslation } from 'react-i18next'
import { StringMap } from 'i18next'
import { useGetPlansDetails } from 'Features/accountSettings/api/getPlansDetails'
import { format } from 'date-fns'

export const RevokeCancellationConfirmation = ({
  isOpen,
  isLoading,
  isSuccess,
  setIsOpen,
  onRevokeCancellation,
}: {
  isOpen: boolean
  isLoading: boolean
  isSuccess: boolean
  setIsOpen: (val: boolean) => void
  onRevokeCancellation: () => void
}) => {
  const { t } = useTranslation('accountSettings')
  const { data: plansDetails } = useGetPlansDetails()

  const translate = (key: string, options?: StringMap) =>
    t(`plan_details.revoke_cancellation${isSuccess ? '_successful' : ''}.${key}`, options)

  return (
    <DesignedModal
      isOpen={isOpen}
      title={translate('title')}
      onOpenChange={setIsOpen}
      style={{ width: '600px', maxWidth: '90vw' }}
      text={translate(`description`, {
        date: format(new Date(plansDetails?.currentPeriodEnd || 0), 'MMM dd yyyy'),
      })}
      actions={
        isSuccess ? (
          <Button
            variant="outline"
            text={translate('close_button')}
            onClick={() => setIsOpen(false)}
          />
        ) : (
          <>
            <Button
              variant="ghost"
              text={translate('cancel_button')}
              onClick={() => setIsOpen(false)}
            />
            <Button
              text={translate('confirm_button')}
              onClick={() => onRevokeCancellation()}
              loading={isLoading}
            />
          </>
        )
      }
    />
  )
}
